import { memo } from "react";

import { ProductSelector as ProductSelectorData } from "./ProductSelector.data";
import { ProductSelectorProvider } from "./ProductSelectorContext";

const ProductSelectorRootBase = ({ id }: { id?: string }) => {
  return (
    <ProductSelectorProvider id={id}>
      <ProductSelectorData />
    </ProductSelectorProvider>
  );
};

export const ProductSelector = memo(ProductSelectorRootBase);
